export function useBidrPixel() {
  const {
    bidrPixelPageVisit,
    bidrPixelRegistration,
    bidrPixelWalletConnect,
    bidrPixelFirstTimeDeposit,
    bidrPixelDeposit,
  } = useRuntimeConfig().public;

  const fillQueryParams = (query: string, params: Record<string, any>) => {
    return query.replace(/\[([A-Z_]+)\]/g, (_, key) => {
      const normalizedKey = key.toLowerCase();
      return params[normalizedKey] ?? '';
    });
  };

  const fetchPageVisitPixel = () => {
    if (!bidrPixelPageVisit) return;

    const pixel = new Image(0, 0);
    pixel.src = bidrPixelPageVisit;
  };

  const fetchRegistrationPixel = () => {
    if (!bidrPixelRegistration) return;

    const url = fillQueryParams(bidrPixelRegistration, { cachebuster: Date.now() });
    const pixel = new Image(0, 0);
    pixel.src = url;
  };

  /**
   * Most likely will be fetched from BE side
   */
  const fetchWalletConnectPixel = (params: { value: string; order: string }) => {
    if (!bidrPixelWalletConnect) return;

    const url = fillQueryParams(bidrPixelWalletConnect, { ...params, cachebuster: Date.now() });
    const pixel = new Image(0, 0);
    pixel.src = url;
  };

  /**
   * Most likely will be fetched from BE side
   */
  const fetchFirstTimeDepositPixel = (params: { value: string; order: string }) => {
    if (!bidrPixelFirstTimeDeposit) return;

    const url = fillQueryParams(bidrPixelFirstTimeDeposit, { ...params, cachebuster: Date.now() });
    const pixel = new Image(0, 0);
    pixel.src = url;
  };

  /**
   * Most likely will be fetched from BE side
   */
  const fetchDepositPixel = (params: { value: string; order: string }) => {
    if (!bidrPixelDeposit) return;

    const url = fillQueryParams(bidrPixelDeposit, { ...params, cachebuster: Date.now() });
    const pixel = new Image(0, 0);
    pixel.src = url;
  };

  return {
    fetchPageVisitPixel,
    fetchRegistrationPixel,
    fetchWalletConnectPixel,
    fetchFirstTimeDepositPixel,
    fetchDepositPixel,
  };
}
